const state = {
    barRight:false,
    messages:false,
    occurrences:false,
    modalPause:false,
    modalSchedule:false,
    modalCall:false,
    showHistory:false,
    allOccurrence:true,
    newOccurrence:false,
    deslog:true,
    getButtonClient:false,
    showSpearhead:false,
    mute:false,
    yesOrNot:false,
    yes:false,
    showMessageAutomatic:false,
	isReconnect: false,
    contacts: false,
    listContacts: false,
    commercialICampaign: false,
    commercialIICampaign: false,
    commercialIIICampaign: false,
};

const getters = {
    getYes:state=>state.yes,
    getYesOrNot:state=>state.yesOrNot,
    getShowBarRight:state => state.barRight,
    getOccurrences:state => state.occurrences,
    getAllOccurrence:state => state.allOccurrence,
    getNewOccurrence:state => state.newOccurrence,
    getShowHistory:state => state.showHistory,
    getMessages:state => state.messages,
    getModalCall: state => state.modalCall,
    getModalSchedule: state => state.modalSchedule,
    getModalPause: state=>state.modalPause,
    getDeslog: state =>state.deslog,
    getButtonClient:state => state.clickButtonClien,
    getShowSpearhead:state => state.showSpearhead,
    getMute:state => state.mute,
    getShowMessageAutomatic:state => state.showMessageAutomatic,
	isReconnect: state => state.isReconnect,
    getContacts: state => state.contacts,
    getListContacts: state => state.listContacts,
    getShowCommercialICampaign: state => state.commercialICampaign,
    getShowCommercialIICampaign: state => state.commercialIICampaign,
    getShowCommercialIIICampaign: state => state.commercialIIICampaign,
    getShowAnyCommercialCampaign: state =>
        state.commercialICampaign || state.commercialIICampaign || state.commercialIIICampaign,
}

const actions = {
    setShowMessageAutomatic({commit}){
        commit('toogleShowMessageAutomatic')
    },
    async setYesOrNot({commit}){
        commit('tootleYesOrNot')
    },
    async setMute({commit}){
        commit('toogleMute');
    },
    async setMutePhone({commit}){
        commit('toogleMutePhone');
    },
    async setShowBarRight({commit}){
        commit('toggleBarRight')
    },
    async setOccurrences({commit}){
        commit('toggleOccurrences')
    },
    async setNewOccurrences({commit}){
        commit('toogleNewOccurrence')
    },
    async setAllOccurrences({commit}){
        commit('toogleAllOccurrence')
    },
    async setShowHistory({commit}){
        state.messages = false;
        state.contacts = false;
        state.listContacts = false;
        // if(state.showHistory == true) return;
        commit('toogleShowHistory')
    },
    async setMessage({commit}){
        state.showHistory = false;
        state.contacts = false;
        state.listContacts = false;
        // if(state.messages == true) return;
        commit('toggleMessages')
    },
    async settModalCall({commit}){
        commit('toogleModalCall')
    },
    async setModalSchedule({commit}){
        commit('toogleModalSchedule')
    },
    async setModalPause({commit}){
        commit('toogleModalPause')
    },
    async setDeslog({commit}){
        commit('toogleDeslog')
    },
    /*async setButtonClient({commit}){
        commit('toogleDeslog')
    },*/
    async setShowSpearhead({commit}){
        commit('toogleShowSpearhead')
    },

	setisReconnect(value){
		state.isReconnect = value;
	},
    async setContacts({ commit }) {
		state.showHistory = false;
		state.messages = false;
        state.campanha = false;
        state.listContacts = false;
        // if(state.contacts == true) return;
        commit('toogleContacts');
    },

    async setListContacts({ commit }) {
		state.showHistory = false;
		state.messages = false;
        state.campanha = false;
        state.contacts = false;

        // if(state.contacts == true) return;
        commit('toogleListContacts');
    },

    /**
     * Campanhas de ligação (Comercial I/II/III).
     *
     * Ao abrir uma campanha os painéis de Whatsapp/contatos/histórico são
     * fechados para que a campanha ocupe a área principal, mas a campanha em si
     * não depende de nenhum deles: ela é alimentada apenas pela telefonia.
     */
    async setShowCommercialICampaign({ commit }) {
        commit('toggleCommercialICampaign');
    },
    async setShowCommercialIICampaign({ commit }) {
        commit('toggleCommercialIICampaign');
    },
    async setShowCommercialIIICampaign({ commit }) {
        commit('toggleCommercialIIICampaign');
    },
}

/**
 * Fecha os painéis que disputam a área principal com a campanha.
 * Chamado apenas quando uma campanha está sendo aberta.
 */
const hideSidePanels = (state) => {
    state.messages = false;
    state.showHistory = false;
    state.contacts = false;
    state.listContacts = false;
}

const mutations = {
    toogleYes:(state,yes)=>(state.yes = !state.yes),
    tootleYesOrNot:(state,yesOrNot)=>(state.yesOrNot = !state.yesOrNot),
    toggleBarRight: (state,barRight)=>(state.barRight = !state.barRight),
    toggleMessages:(state,messages)=> (state.messages = !state.messages),
    toggleOccurrences: (state, occurrences)=>(state.occurrences = !state.occurrences),
    toogleModalPause:(state,modalPause)=>(state.modalPause = !state.modalPause),
    toogleModalSchedule:(state,modalSchedule)=>(state.modalSchedule =!state.modalSchedule),
    toogleModalCall:(state,modalCall)=>(state.modalCall = !state.modalCall),
    toogleShowHistory:(state,showHistory)=>(state.showHistory = !state.showHistory),
    toogleAllOccurrence:(state,allOccurrence)=>(state.allOccurrence = !state.allOccurrence),
    toogleNewOccurrence:(state,newOccurrence)=>(state.newOccurrence = !state.newOccurrence),
    toogleDeslog:(state,deslog)=>(state.deslog = !state.deslog),
    toogleShowSpearhead:(state,showSpearhead)=>(state.showSpearhead = true),
    toogleMute:(state,mute)=>(state.mute = !state.mute),
    toogleMutePhone:(state,mute)=>(state.mutePhone = !state.mutePhone),
    toogleShowMessageAutomatic:(state,showMessageAutomatic) =>(state.showMessageAutomatic = !state.showMessageAutomatic),
    toogleContacts: (state, contacts) => (state.contacts = !state.contacts),
    toogleListContacts: (state, listContacts) => (state.listContacts = !state.listContacts),

    // Só uma campanha comercial pode estar ativa por vez.
    toggleCommercialICampaign: (state) => {
        if (!state.commercialICampaign) {
            state.commercialIICampaign = false;
            state.commercialIIICampaign = false;
            hideSidePanels(state);
        }
        state.commercialICampaign = !state.commercialICampaign;
    },
    toggleCommercialIICampaign: (state) => {
        if (!state.commercialIICampaign) {
            state.commercialICampaign = false;
            state.commercialIIICampaign = false;
            hideSidePanels(state);
        }
        state.commercialIICampaign = !state.commercialIICampaign;
    },
    toggleCommercialIIICampaign: (state) => {
        if (!state.commercialIIICampaign) {
            state.commercialICampaign = false;
            state.commercialIICampaign = false;
            hideSidePanels(state);
        }
        state.commercialIIICampaign = !state.commercialIIICampaign;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
